import * as Effects from 'redux-saga/effects'
import { dbError, roomsFlushed } from '../../../actions/synchronize/flushData'
import db from '../../../database/indexedDb'

export default function*() {
  try {
    yield db.rooms.clear()

    yield Effects.put(roomsFlushed())
  } catch (e) {
    yield Effects.put(dbError(e))
  }
}
